"use client"

import { useEffect } from "react"
import { ErrorState } from "@/components/error-state"
import { reportClientError } from "@/lib/errorReporting"

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error(error)
    reportClientError(error)
  }, [error])

  return (
    <ErrorState
      code="Ops"
      eyebrow="Imprevisto temporário"
      title="Encontramos um pequeno obstáculo"
      description="Não foi possível concluir essa etapa agora. Seus dados continuam seguros; tente novamente em instantes ou volte ao início para seguir por outro caminho."
      imageSrc="/illustrations/error-unexpected.png"
      imageAlt="Profissional realizando uma manutenção tranquila em um equipamento"
      onRetry={reset}
    />
  )
}
